'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

const updateAccountInfoResponse = function(data) {
    if (data && data.responseOK) {
        const oldCookie = decodeURIComponent(Odigeo.Utils.readCookie('sso_remember_me')).split(';');
        const email = oldCookie[0] || '';
        const displayName = data.displayName || email;
        const newCookie = [email, displayName].concat(oldCookie.splice(2, oldCookie.length - 1));
        const updatedCookie = encodeURIComponent(newCookie.join(';'));

        Odigeo.Utils.createCookie('sso_remember_me', updatedCookie);
        Odigeo.trigger(this.id + ':ssoRememberMeCookieUpdated');

        this.model.userDTO = data.userDTO;
    } else {
        this.model.action = 'error';
    }

    if (Odigeo._.isEmpty(this.model.userID)) {
        this.setTemplate();
        this.showPassengers();
    } else {
        Odigeo.Router.navigate('frequentpassengers', {});
    }
};

module.exports = createWidgetFactory({
    name: 'frequent_passengers_manager',
    modelClass: require('./model'),
    viewClass: require('./view'),

    methods: {
        getAccountInfoOk(data) {
            if (!this.model.initialized) {
                this.model.userDTO = data.userDTO;
            }

            this.setTemplate();

            if (Odigeo._.isEmpty(this.model.userID)) {
                this.showPassengers();
            } else if (this.model.userID === 'new') {
                this.showEditorNew();
            } else {
                this.showEditorModify(this.model.userID);
            }
        },

        setUserID(data) {
            this.model.userID = data.userID;
            this.loading();
        },

        updateAccountInfoOk: updateAccountInfoResponse,

        updateAccountInfoError: updateAccountInfoResponse,

        updateAccountInfoWithError: updateAccountInfoResponse,
    },
});
